import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initSentry } from './lib/sentry';
import { installSupabaseInstrumentation } from './lib/supabaseInstrumentation';
import { installChunkReloadHandler } from './lib/chunkReload';

initSentry();
installSupabaseInstrumentation();
installChunkReloadHandler();

createRoot(document.getElementById('root')!).render(<App />);
